import { RootState } from 'src/store/store';
import { PaymentPeriod } from 'src/types/tax';

export const selectUsersTaxableLicensePeriods = (
  state: RootState
): PaymentPeriod[] => state.dashboard.usersTaxableLicenses;

export const selectUsersTaxableLicensePeriodsInProgress = (
  state: RootState
): boolean => state.dashboard.isGetUsersTaxableLicensesInProgress;

export const selectUsersTaxableLicensePeriodsSuccess = (
  state: RootState
): boolean => state.dashboard.isGetUsersTaxableLicensesSuccess;

export const selectUsersTaxableLicensePeriodsErrorMsg = (
  state: RootState
): string => state.dashboard.usersTaxableLicensesErrorMsg;
